module.exports = __webpack_public_path__ + "img/Mastercard.67b35a75.svg";